import { render, staticRenderFns } from "./gjjInfo.vue?vue&type=template&id=76b89532&scoped=true"
import script from "./gjjInfo.vue?vue&type=script&lang=js"
export * from "./gjjInfo.vue?vue&type=script&lang=js"
import style0 from "./gjjInfo.vue?vue&type=style&index=0&id=76b89532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b89532",
  null
  
)

export default component.exports